import { UserEarnActionListResponseDataItem } from '@utx/utx-client';
import BigNumber from 'bignumber.js';
import { View } from 'dripsy';
import React from 'react';
import { LayoutChangeEvent } from 'react-native';
import { FormSkeleton } from '../../components/FormSkeleton';
import { RedeemStackRoutes, RedeemStackScreenProps } from './types';

export interface RedeemMainProps {
  subscription: UserEarnActionListResponseDataItem;
  onUpdate: () => void;
  onLayout: (event: LayoutChangeEvent) => void;
  refreshPortfolio: () => void;
}

export const RedeemMain: React.FC<RedeemStackScreenProps<RedeemStackRoutes.Main>> = ({ navigation, route }) => {
  const { subscription, onUpdate, onLayout, refreshPortfolio, goBack } = route.params;

  if (goBack) {
    navigation.goBack();
    return null;
  }

  if (subscription) {
    if (subscription.maturityDate) {
      navigation.navigate(RedeemStackRoutes.Confirm, {
        subscription,
        netRedemptionAmount: new BigNumber(subscription.amount).plus(subscription.rewardsAccrued).toString(),
        onUpdate,
        onLayout,
        refreshPortfolio
      });
    } else {
      navigation.navigate(RedeemStackRoutes.Edit, {
        subscription,
        onUpdate,
        onLayout,
        refreshPortfolio
      });
    }
    return null;
  }

  return (
    <View onLayout={onLayout}>
      <FormSkeleton />
    </View>
  );
};
